var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grid"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 480,
    x2: 512,
    y2: 480
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 448,
    x2: 512,
    y2: 448
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 416,
    x2: 512,
    y2: 416
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 384,
    x2: 512,
    y2: 384
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 352,
    x2: 512,
    y2: 352
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 320,
    x2: 512,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 288,
    x2: 512,
    y2: 288
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 256,
    x2: 512,
    y2: 256
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 224,
    x2: 512,
    y2: 224
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 192,
    x2: 512,
    y2: 192
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 160,
    x2: 512,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 128,
    x2: 512,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 96,
    x2: 512,
    y2: 96
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 64,
    x2: 512,
    y2: 64
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 32,
    x2: 512,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 480,
    y1: 0,
    x2: 480,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 448,
    y1: 0,
    x2: 448,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 416,
    y1: 0,
    x2: 416,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 384,
    y1: 0,
    x2: 384,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 352,
    y1: 0,
    x2: 352,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 320,
    y1: 0,
    x2: 320,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 288,
    y1: 0,
    x2: 288,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 256,
    y1: 0,
    x2: 256,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 224,
    y1: 0,
    x2: 224,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 192,
    y1: 0,
    x2: 192,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 160,
    y1: 0,
    x2: 160,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 128,
    y1: 0,
    x2: 128,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 96,
    y1: 0,
    x2: 96,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 64,
    y1: 0,
    x2: 64,
    y2: 512
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#A9CCDB",
    strokeMiterlimit: 10,
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 512
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1D1D1B",
    d: "M177.615,288c7.438-36.521,39.688-64,78.396-64 c38.709,0,70.958,27.479,78.376,64h32c-7.834-54.125-54.084-96-110.376-96c-56.271,0-102.541,41.875-110.375,96H177.615z  M256.011,160c8.833,0,16-7.167,16-16v-32c0-8.833-7.167-16-16-16c-8.832,0-16,7.167-16,16v32 C240.011,152.833,247.179,160,256.011,160z M403.073,156.917c-6.249-6.25-16.374-6.25-22.625,0l-22.625,22.625 c-6.249,6.25-6.249,16.375,0,22.625c6.251,6.25,16.376,6.25,22.625,0l22.625-22.625 C409.323,173.292,409.323,163.167,403.073,156.917z M154.177,179.542l-22.625-22.625c-6.249-6.25-16.373-6.25-22.625,0 c-6.249,6.25-6.249,16.375,0,22.625l22.625,22.625c6.252,6.25,16.376,6.25,22.625,0 C160.429,195.917,160.429,185.792,154.177,179.542z M352.011,320h-192c-8.832,0-16,7.167-16,16s7.168,16,16,16h192 c8.833,0,16-7.167,16-16S360.844,320,352.011,320z M320.011,384h-128c-8.832,0-16,7.167-16,16s7.168,16,16,16h128 c8.833,0,16-7.167,16-16S328.844,384,320.011,384z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.4efaeb39a4980183e1422fa78c756e90.svg";
export { ForwardRef as ReactComponent };